
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteF as ObiOwnShipRemoteFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-f.js';
 
 
 

 
 export const ObiOwnShipRemoteF = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-f',
   elementClass: ObiOwnShipRemoteFElement,
   events: {
     
   }
  });
 
 